<template>
  <v-hover v-slot:default="{ hover }">
    <v-list class="pa-0 ma-0">
      <v-list-item class="py-4" v-for="item in items" :key="item.title">
        <v-list-item-icon>
          <v-icon class="display-1 headline" color="black" v-if="tipo == 'geo'">mdi-near-me</v-icon>

          <v-icon
            class="display-1 headline"
            color="success"
            v-else-if="tipo == 'cache'"
          >mdi-star-outline</v-icon>

          <v-icon class="display-1 headline" color="gray" v-else>mdi-clock-outline</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{obj.calle}} {{obj.numero}}</v-list-item-title>
          <v-list-item-subtitle>{{obj.adicional}} {{obj.adicional ? ',' : ''}} {{obj.municipio}} {{obj.cp}} {{obj.provincia}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="tipo == 'libreta'">
          <v-menu transition="scale-transition" bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list width="256">
              <v-list-item
                v-for="(item, i) in menuDireccion"
                :key="i"
                @click="manejadorFuncion(item.click,obj)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
        <v-list-item-action v-if="tipo == 'cache'">
          <v-menu transition="scale-transition" bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list width="256">
              <v-list-item @click="eliminarDirCache(item.click,obj)">
                <v-list-item-title>Eliminar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
  </v-hover>
</template>


<script>
import { mapState } from "vuex";

export default {
  name: "direccion-card",
  props: {
    obj: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      required: false,
      default: "geo"
    }
  },
  data() {
    return {
      items: [
        {
          icon: true,
          title: "Jason Oner",
          subtitle: "Jan 9, 2014",
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
        }
      ],
      menuDireccion: [
        //{ title: "Editar", click: "editar" },
        { title: "Eliminar", click: "eliminar" }
      ]
    };
  },
  computed: {
    ...mapState({
      formaEnvio: state => state.pedido.activePedido.forma_envio
    }),
    confirmDialog: {
      get() {
        return this.$store.state.direcciones.confirmDialog;
      },
      set(v) {
        this.$store.commit("direcciones/setConfirmDialog", v);
      }
    }
  },
  methods: {
    eliminarDirCache(dir) {
      this.$store.commit("direcciones/resetDirCache");
    },
    manejadorFuncion(nombre, obj) {
      this[nombre](obj);
    },
    eliminar(obj) {
      const id = obj.id;

      this.$confirm(
        "¿Desea eliminar definitivamente esta dirección de su libreta? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350
        }
      ).then(res => {
        if (res) {
          this.eliminarConfirmado(id);
        }
      });
    },
    editar() {
      const dir = this.obj;
      this.$store.commit("pedido/setModoEditarDireccion", true);
      this.$store.commit("direcciones/setAddressOnOpenDialog", dir);
      this.$store.commit("pedido/setAddressObjectSinFiltro", dir);
      this.$store.commit("pedido/setDialogDireccion", true);
    },
    eliminarConfirmado(id) {
      this.loadingDialog = true;
      const _vue = this;
      //iniciar loading
      return this.$store
        .dispatch("direcciones/eliminarDireccion", id)
        .then(r => {
          this.$store.commit(
            "snackbar/setMensajeSuccess",
            { msj: "Dirección eliminada." },
            { root: true }
          );
        })
        .catch(e => {
          this.$store.commit(
            "snackbar/setMensajeDanger",
            { msj: "Error al eliminar la dirección: " + e },
            { root: true }
          );
        })
        .finally(() => {
          _vue.loadingDialog = false;
        });
    }
  },
  watch: {
    // obj(newV, oldV){
    //   if(newV != oldV)  this.$forceUpdate()
    //   console.log( newV, oldV, newV != oldV )
    // }
  },
  updated() {},
  mounted() {
    console.log(this.obj);
  }
};
</script>

<style scoped>
.f-size-18 {
  font-size: 18px;
}
.border {
  border: 1px solid #000;
}
</style>